import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container } from "components";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "services/api";

export const DashboardD = () => {
  const [dashboard, setDashboard] = useState(null);
  const navigate = useNavigate();
  const fetchDashBoard = async () => {
    try {
      const response = await api.get("/user-dashboard");
      setDashboard(response?.data?.data[0]);
      console.log("fetchDashBoard:", response?.data?.data);
    } catch (error) {
      console.log("fetchDashBoard error:", error);
    }
  };

  useEffect(() => {
    fetchDashBoard();
  }, []);

  return (
    <Container>
      <div class="content-wrapper ">
        <div
          class="container-xxl flex-grow-1 container-p-y"
          style={{ height: "43px" }}>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item active">Dashboard</li>
            </ol>
          </nav>
          <div class="row">
            <div class="col-sm-6 col-lg-3 mb-4">
                  <div class="card card-border-shadow-primary">
                    <div class="card-body">
                      <div class="d-flex align-items-center mb-2 pb-1">
                          <div class="avatar me-2">
                              <span class="avatar-initial rounded bg-label-primary">
                                   <i class="ti ti-badge" />
                              </span>
                          </div>
                          <h4 class="ms-1 mb-0">{dashboard?.totalPlans || 0}</h4>
                      </div>
                      <p class="mb-1">Number of plans</p>
                    </div>
                  </div>
            </div>
            <div class="col-sm-6 col-lg-3 mb-4">
                <Link to="/enrolledPlans">
                  <div class="card card-border-shadow-success">
                    <div class="card-body">
                      <div class="d-flex align-items-center mb-2 pb-1">
                        <div class="avatar me-2">
                          <span class="avatar-initial rounded bg-label-success">
                             <i class="ti ti-crown" />
                          </span>
                        </div>
                        <h4 class="ms-1 mb-0">
                          {dashboard?.totalActivePlans || 0}
                        </h4>
                      </div>
                      <p class="mb-1">Number of active plans</p>
                    </div>
                  </div>
              </Link>
            </div>
            <div class="col-sm-6 col-lg-3 mb-4">
              <Link to="/enrolledPlans">
                  <div class="card card-border-shadow-danger">
                    <div class="card-body">
                      <div class="d-flex align-items-center mb-2 pb-1">
                        <div class="avatar me-2">
                          <span class="avatar-initial rounded bg-label-danger">
                             <i class="ti ti-calendar-x" />
                          </span>
                        </div>
                        <h4 class="ms-1 mb-0">
                          {dashboard?.totalPlansExpired || 0}
                        </h4>
                      </div>
                      <p class="mb-1">Number of expired plans</p>
                    </div>
                  </div>
              </Link>
            </div>
          </div>
          <div class="col-12 order-5">
            <div class="card">
              <div class="card-header d-flex align-items-center justify-content-between">
                <div class="card-title mb-0">
                  <h5 class="m-0 me-2">Plans</h5>
                </div>
              </div>
              <div class="card-datatable table-responsive">
                <table class="table">
                  <thead class="border-top">
                    <tr>
                      <th>plan name</th>
                      <th>Plan Expires in (Days)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(dashboard?.activePlansWithDays) &&
                      dashboard.activePlansWithDays.map((plan, index) => (
                        <tr key={plan.enroll_id || index}>
                          <td onClick={()=>{navigate(`/dashBEnrollPI/${plan?.enroll_id}`);}} style = {{color:"blue", cursor:"pointer"}}>{plan.title}</td>
                          <td>{plan.no_of_days_to_expire} days</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};
